
import { useState } from 'react';

export default function FAQSection() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: '夜間に止まったら困る／24時間サポートですか？',
      answer: '標準は平日8–17時です。その代わり、"止まりにくい設計"で確率と影響を徹底的に削ります。寿命先読みアラート／予備在庫／簡易復旧手順（動画＆紙）、安全停止→品質保全、翌朝の即再開を前提とした設計になっています。'
    },
    {
      question: '人が足りず運用できるか不安',
      answer: '作業を装置内に標準化しているため、新人でも同品質・同タクトの段取りが可能です。従来の技能者依存から脱却し、誰でも安定した作業ができる仕組みを提供します。'
    },
    {
      question: '監査に耐えられる？',
      answer: 'トルク・履歴ログが客観エビデンスとして記録されます。"言い訳不要"の体制で、顧客監査や品質問い合わせに即座に対応できます。'
    },
    {
      question: '既存設備との連携は可能ですか？',
      answer: 'venturion/TMSとの連携により、測定→交換→エビデンス管理を一体化できます。'
    },
    {
      question: '投資回収期間の目安は？',
      answer: '多くのお客様で3-5年での投資回収を実現しています。停止時間削減、人件費削減、品質改善効果を総合的に評価すると、更に短期間での回収が可能です。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            【よくある疑問】
          </h2>
          <p className="text-xl text-gray-600">
            導入前の不安にお答えします
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-50 rounded-lg overflow-hidden border border-gray-200">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover-bg-gray-100 transition-colors cursor-pointer"
              >
                <span className="font-semibold text-gray-900 pr-4">
                  Q. {faq.question}
                </span>
                <div className="flex-shrink-0">
                  <i className={`ri-arrow-${openFAQ === index ? 'up' : 'down'}-s-line text-xl text-gray-500`}></i>
                </div>
              </button>
              
              {openFAQ === index && (
                <div className="px-6 pb-4">
                  <div className="border-l-4 border-yellow-500 pl-4">
                    <p className="text-gray-700 leading-relaxed">
                      <strong className="text-yellow-600">A. </strong>
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-yellow-800 mb-2">
              その他のご質問がございましたら
            </h3>
            <p className="text-yellow-700 mb-4">
              専門スタッフが詳しくお答えいたします
            </p>
            <button className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
              個別相談を申し込む
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
